'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';
import englishTexts from '../languages/english.json';
import bosnianTexts from '../languages/bosnian.json';
import arabicTexts from '../languages/arabic.json';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [currentLanguage, setCurrentLanguage] = useState('EN');
  const [texts, setTexts] = useState(englishTexts);
  const [isRTL, setIsRTL] = useState(false);

  useEffect(() => {
    // Check if there's a saved language preference
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
      
      if (savedLanguage === 'EN') {
        setTexts(englishTexts);
        setIsRTL(false);
      } else if (savedLanguage === 'BA') {
        setTexts(bosnianTexts);
        setIsRTL(false);
      } else if (savedLanguage === 'AR') {
        setTexts(arabicTexts);
        setIsRTL(true);
      }
    }
  }, []);

  const switchLanguage = (language) => {
    setCurrentLanguage(language);
    localStorage.setItem('language', language);
    
    if (language === 'EN') {
      setTexts(englishTexts);
      setIsRTL(false);
    } else if (language === 'BA') {
      setTexts(bosnianTexts);
      setIsRTL(false);
    } else if (language === 'AR') {
      setTexts(arabicTexts);
      setIsRTL(true);
    }
  };

  return (
    <LanguageContext.Provider value={{ texts, currentLanguage, switchLanguage, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
} 